import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import PageHeader from "components/common/PageHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Incidents = () => {

    useEffect(() => {
        document.title = `Incidents`
    }, [])

    return (<>
        <PageHeader
            title="Incidents"
            description="Incidents, Tickets and Claims management"
            className="mb-3"
        />
    </>)
}

export default Incidents